import { module } from 'modujs';
import 'fslightbox';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (typeof refreshFsLightbox === 'function') {
            refreshFsLightbox();
        }
    }
}